import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useCallback, useState } from "react";
import { CreateExecutionCommand, ScenarioRO } from "../../../api/api";
import { Dialog } from "../../../components/Hooks/Dialog/DialogProvider";
import PopupDialog from "../../../components/Form/PopupDialog";
import SettingsTextField from "../../../components/Settings/Old/Form/SettingsTextField";
import SettingsLabel from "../../../components/Settings/Old/Form/SettingsLabel";
import VariableForm from "../../../components/Variables/VariableForm";

interface Props {
    scenario: ScenarioRO;
}

const useStyles = makeStyles({
    question: {
        marginBottom: "1rem"
    }
});

const CreateExecutionDialog: Dialog<CreateExecutionCommand, Props> = props => {
    const classes = useStyles();

    const {
        scenario,
        onCancel,
        onAccept
    } = props;

    const [valid, setValid] = useState(false);
    const [name, setName] = useState("");
    const [rampUpPeriodMs, setRampUpPeriodMs] = useState("1000");
    const [variables, setVariables] = useState<{ [key: string]: string }>({});

    const onAcceptClicked = useCallback(() => {
        onAccept({
            name: name,
            rampUpPeriodMs: parseInt(rampUpPeriodMs),
            scenarioId: scenario.id,
            variables: variables
        });
    }, [name, onAccept, rampUpPeriodMs, scenario.id, variables]);

    return (
        <PopupDialog
            open
            onSecond={onCancel}
            onFirst={onAcceptClicked}
            firstTitle="Erstellen"
            secondTitle="Abbrechen"
            firstDisabled={!valid}
            title="Ausführung erstellen">

            <Typography
                variant="body1"
                className={classes.question}>
                Bitte füllen Sie die folgenden Felder aus, um die neue Ausführung zu erstellen.
            </Typography>

            <SettingsTextField
                label="Name"
                value={name}
                onChanged={setName} />

            <SettingsTextField
                label="Ramp-Up-Intervall (ms)"
                type="number"
                value={rampUpPeriodMs}
                onChanged={setRampUpPeriodMs} />

            {scenario.variables.length > 0 && (

                <>

                    <SettingsLabel>Variablen</SettingsLabel>

                    <VariableForm
                        variables={scenario.variables}
                        onValidate={setValid}
                        onUpdate={(variableName, value) => setVariables({
                            ...variables,
                            [variableName]: value
                        })}
                        values={variables} />

                </>

            )}

        </PopupDialog>
    );
};

export default CreateExecutionDialog;
